module.exports = __webpack_public_path__ + "fontawesome-webfont.912ec66d7572ff821749.svg";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = styles